import { createAsyncThunk } from '@reduxjs/toolkit';

import { ContentNuggetBookmark, ContentNuggetBookmarkTypes } from '@backrs_ui/common-ui';

import { fetchWrapper as fetch } from '@backrs_ui/grow-ui/src/utils/fetch/fetchWrapper';
import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

// Thunk to post a content nugget as bookmarked
export const postContentNuggetBookmark = createAsyncThunk(
  'user/postContentNuggetBookmark',
  async (
    {
      itemId,
      type,
    }: {
      itemId: number;
      type: ContentNuggetBookmarkTypes;
    },
    { rejectWithValue },
  ) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-nugget-bookmark`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...(type === 'nugget' ? { nugget: { id: itemId } } : undefined),
          ...(type === 'scholarship' ? { scholarship: { id: itemId } } : undefined),
          ...(type === 'career-path' ? { career_path: { id: itemId } } : undefined),
          ...(type === 'profile' ? { profile: { id: itemId } } : undefined),
          ...(type === 'external-profile' ? { external_profile: { id: itemId } } : undefined),
          ...(type === 'internship' ? { internship: { id: itemId } } : undefined),
          ...(type === 'post' ? { post: { id: itemId } } : undefined),
          ...(type === 'college' ? { college: { id: itemId } } : undefined),
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return rejectWithValue(`Failed to post content nugget bookmark with error: ${error}`);
    }
  },
);

// Thunk to retrieve all bookmarked content nuggets on bootstrap
export const fetchAllContentNuggetBookmarks = createAsyncThunk(
  'user/fetchAllContentNuggetBookmarks',
  async (_, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-nugget-bookmark`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentNuggetBookmark[];
    } catch (error) {
      return rejectWithValue(`Failed to fetch bookmarked content nuggets with error: ${error}`);
    }
  },
);

export const deleteContentNuggetBookmark = createAsyncThunk(
  'user/deleteContentNuggetBookmark',
  async (bookmarkId: number, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-nugget-bookmark/${bookmarkId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return rejectWithValue(`Failed to delete content nugget bookmark with error: ${error}`);
    }
  },
);
